import React from "react";

const CardDetails = ({
	register,
	error,
	required = false,
	className = "",
	id,
}) => {
	return (
		<div className={`donate-field__card-details ${className}`}>
			<input
				type="text"
				id={id}
				className={`donate-field__input ${
					error ? "donate-field__input--error" : ""
				}`}
				placeholder="Card number"
				{...register(id, {
					required: required ? "Card details are required" : false,
				})}
			/>
		</div>
	);
};

export default CardDetails;
